import { defaultEnvironmentConfigs, EEnvironmentName, IEnvironment } from './environment.defaults';

export const environment: IEnvironment = {
  ...defaultEnvironmentConfigs,
  apiUrl: 'https://campaign-api.shikenso.org/',
  clarity: {
    enabled: true,
    projectId: 'v08cqzvsey',
  },
  environmentName: EEnvironmentName.test,
  eventTrackingConsoleLogsEnabled: true,
  eventTrackingEnabled: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDu6gIkKynO-OigkYIJEjXWMrqZKG8VMGM',
    appId: '1:59820723976:web:e20d83529b925dd51466bd',
    authDomain: 'campaignmanagementtest.firebaseapp.com',
    messagingSenderId: '59820723976',
    projectId: 'campaignmanagementtest',
    storageBucket: 'campaignmanagementtest.firebasestorage.app',
  },
  hubspot: {
    enabled: true,
    portalId: '145496113',
  },
  production: false,
  sentry: {
    dsn: 'https://8aa8b9b468239f8bf58fc8a101e84e82@o4509744862134272.ingest.de.sentry.io/4510023326826576',
    profilesSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
  },
};
